<template>
    <div class="Software">
        <div class="pageContent">
            <TopLogoBar logoColor="black" logoSpecial="software" textColor="#000" title="SOFTWARE" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-6">
                        <p class="descriptionText">
                            page93® realizza software che soddisfano le esigenze di
                            gestione, di produzione su commessa e in serie, e di vendita
                            BtoB e BtoC.<br><br>

                            page93® è partner certificato Microarea Zucchetti dal 1993.
                            Consulenti altamente formati affiancano il cliente dal <i>pre-sale</i>,
                            per aiutarlo ad analizzare le criticità e proporre la soluzione
                            più adatta a soddisfare le esigenze delle aziende clienti.
                            <br><br>

                            Il modello di business di page93® è <i>clientecentrico</i>.
                            Instaurare un rapporto di fiducia reciproca con i
                            nostri assistiti che vengono guidati nel percorso di
                            <i>setup</i> del nuovo sistema gestionale è nostra prerogativa.
                            personale altamente qualificato accompagna poi il cliente
                            per tutta la durata del processo supportandolo nel cavalcare
                            l’onda del cambiamento ambientale con agilità e prontezza.
                            <br><br>

                            Da oltre 25 anni il team di sviluppatori software page93®
                            propone soluzioni verticali, progettate e realizzate <i>in-house</i>,
                            che integrano i software gestionali Mago.net e Mago4:
                            la soluzione ERP modulare, multilingua,
                            personalizzabile e facile da usare, studiata per risolvere tutte
                            le esigenze gestionali dell'azienda.
                            Si rivolge a tutte le PMI per offrire loro soluzioni IT ricche di
                            funzionalità e allo stesso tempo facili da usare e da gestire.

                            <br><br>
                            L’offerta di page93 si completa con le soluzioni:<br>
                            <ul style="list-style: disc; margin: 10px 0 0 25px;">
                                <li>Infinity CRM</li>
                                <li>I.Mago</li>
                                <li>DMS</li>
                                <li>Infobusinnes e</li>
                                <li>Rilevazione presenze e controllo accessi Semplice e People Smart</li>
                            </ul>

                            <br>
                            Un modello di business che diventa paradigma, veicola la nostra idea e si traduce in servizi
                            a sostegno dei nostri clienti.
                            <br><br>
                        </p>
                    </div>
                    <div class="column is-6 loghiContainer">
                        <a href="http://www.mago4.com/" target="_blank"><img
                                src="@/assets/images/loghi/MAGO4.png" /></a>
                        <a href="http://www.microarea.it/" target="_blank"><img
                                src="@/assets/images/loghi/microarea.jpg" /></a>
                        <a href="https://www.zucchetti.it/" target="_blank"><img
                                src="@/assets/images/loghi/zuchpartner.jpg" /></a>

                        <div class="page93OffertText" style="margin-top: 50px;">
                            <span style="color: #eb222b;">SCOPRI LE SOLUZIONI GESTIONALI</span> PAGE93®
                            <div class="arrowContainer" @click="$router.push('showcase')">
                                <i class="arrow">
                                    <span></span>
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import TopLogoBar from '@/components/TopLogoBar'
    import Footer from '@/components/Footer'
    export default {
        name: 'Software',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .Software {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            .infoContainer {
                display: flex;
                // height: 100%;
                padding: 20px;
            }

            .descriptionText {
                font-size: 1.1rem;
                font-weight: 900;
                text-align: left;
                text-align: justify;

                @media only screen and (min-width: 1216px) {

                    margin-top: 60px;
                    margin-bottom: 40px;
                    margin-right: 60px;
                    margin-left: 60px;
                    // margin-top: 60px;
                }
            }

            .page93OffertText {
                text-align: center;
                font-weight: 900;
                font-size: 16px;
            }

            .imageContainer {
                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                img {
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }

            .loghiContainer {

                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                display: flex;
                flex-direction: column;
                //justify-content: center;
                align-items: center;

                img {
                    margin: 20px;
                }
            }
        }
    }
</style>